import { render, staticRenderFns } from "./statisticsUserSettingList.vue?vue&type=template&id=adfee144&"
import script from "./statisticsUserSettingList.vue?vue&type=script&lang=js&"
export * from "./statisticsUserSettingList.vue?vue&type=script&lang=js&"
import style0 from "./statisticsUserSettingList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports